import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Loader from "@components/shared/Loader/Loader";
import ClubListingCard from "@components/User/ClubListingCard/ClubListingCard";
import { CONSTANTS } from "@constants/index";
import { ResponseDataMember } from "@models/components/user.model";
import handleResponse from "@services/apiConfig/api.response.service";
import API_SERVICES from "@services/index";
import { RootState } from "@store/index";

export default function Member() {
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState<ResponseDataMember | null>(null);
  const { t } = useTranslation();
  const isFirstLogin = useSelector((state: RootState) => state.auth.firstlogin);
  useEffect(() => {
    getMemberList();
  }, []);
  const deleteMemberInfo = async (rowId: string) => {
    setIsFetching(true);
    const data = await API_SERVICES.USER.DELETE_MEMBER_INFO(rowId);
    const responseData = handleResponse(data);
    setIsFetching(false);

    if (responseData?.ok) {
      getMemberList();
    }
  };
  const getMemberList = async () => {
    setIsFetching(false);
    const data = await API_SERVICES.USER.GET_MEMBER_INFO();
    const responseData = handleResponse(data);
    setData(responseData.data);
    setIsFetching(false);

    if (responseData?.ok) {
      setData(responseData.data);
    }
  };

  const memberCards = data?.clubs?.map(item => {
    const club = {
      ...item,
      isActive: 1,
      isMember: item.memberType === CONSTANTS.USER_INFO.MEMBER,
      isSpecial: item.isSpecial,
      title: item.title,
    };

    return (
      <ClubListingCard
        key={club.clubId}
        club={club}
        deleteMemberInfo={deleteMemberInfo}
      />
    );
  });

  return (
    <div
      className="tab-pane fade show active"
      id="pills-member"
      data-testid="test-member"
    >
      {isFetching && <Loader isLoading={true} />}
      <div className="fg-tab-content-wrap">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              {isFirstLogin ? (
                <>
                  <p>{t("userProfile.foundMemberOfOrganizations")}:</p>
                </>
              ) : (
                <p>{t("userProfile.memberOfOrganizations")}:</p>
              )}

              <div
                className={`fg-member-listing-card-wrap ${!data?.clubs?.length && "empty"}`}
              >
                {memberCards}
                {!data?.clubs?.length && (
                  <span className="fg-no-org">{t("noOrganizationsFound")}</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <hr className="d-none d-sm-block" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
